export default __webpack_public_path__ + "ed3946561360de3fb9a1a6a8cd503f7c.svg";